import { render, staticRenderFns } from "./IsBirlikci.vue?vue&type=template&id=3e73aef4"
import script from "./IsBirlikci.vue?vue&type=script&lang=js"
export * from "./IsBirlikci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports